(function () {
  const desktopQuery = window.matchMedia('(min-width: 768px)');
  const thumbGap = 8;

  function resetFrame(frame) {
    if (!frame) return;
    frame.classList.remove('is-zoomed');
    const img = frame.querySelector('.hindle-v2-product-gallery__image');
    if (!img) return;
    img.style.transform = '';
    img.style.transformOrigin = '';
  }

  function bindFrame(frame) {
    const img = frame.querySelector('.hindle-v2-product-gallery__image');
    if (!img) return;

    frame.addEventListener('mouseenter', () => {
      if (desktopQuery.matches) frame.classList.add('is-zoomed');
    });

    frame.addEventListener('mouseleave', () => {
      resetFrame(frame);
    });

    frame.addEventListener('mousemove', (event) => {
      if (!desktopQuery.matches || !frame.classList.contains('is-zoomed')) return;
      const rect = frame.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(1.5)';
    });
  }

  function getThumbSlide(thumbnailElement) {
    if (!thumbnailElement) return null;
    return thumbnailElement.classList.contains('hindle-v2-product-gallery__thumb-item')
      ? thumbnailElement
      : thumbnailElement.closest('.hindle-v2-product-gallery__thumb-item');
  }

  function attachMediaGalleryCompat(thumbsEl, swiper) {
    thumbsEl.isSlideVisible = (element, offset = 0) => {
      const slide = getThumbSlide(element);
      if (!slide || !swiper?.slides?.length) return true;

      const index = Array.prototype.indexOf.call(swiper.slides, slide);
      if (index < 0) return true;

      const slideLeft = slide.offsetLeft;
      const slideRight = slideLeft + slide.offsetWidth;
      const viewLeft = -swiper.translate;
      const viewRight = viewLeft + swiper.width;

      return slideLeft >= viewLeft - offset && slideRight <= viewRight + offset;
    };

    thumbsEl.slider = {
      scrollTo: ({ left }) => {
        const slides = Array.from(swiper.slides);
        let targetIndex = slides.length - 1;

        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i].offsetLeft >= left - 1) {
            targetIndex = i;
            break;
          }
        }

        swiper.slideTo(targetIndex, 300);
      },
    };
  }

  function destroyThumbSwiper(thumbsEl) {
    if (thumbsEl?.swiperInstance?.destroy) {
      thumbsEl.swiperInstance.destroy(true, true);
      thumbsEl.swiperInstance = null;
    }
  }

  function initThumbSwiper(gallery) {
    const thumbsEl = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbsEl || typeof Swiper === 'undefined') return null;

    destroyThumbSwiper(thumbsEl);

    const swiper = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: thumbGap,
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 0.45,
      },
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.85,
      slideToClickedSlide: false,
    });

    thumbsEl.swiperInstance = swiper;
    attachMediaGalleryCompat(thumbsEl, swiper);

    return swiper;
  }

  function getGallerySlides(gallery) {
    return Array.from(gallery.querySelectorAll('.hindle-v2-product-gallery__viewer .product__media-item'));
  }

  function bindGalleryNav(gallery) {
    const prevBtn = gallery.querySelector('.hindle-v2-product-gallery__nav-btn--prev');
    const nextBtn = gallery.querySelector('.hindle-v2-product-gallery__nav-btn--next');
    if (!prevBtn || !nextBtn) return;

    const getActiveIndex = () =>
      getGallerySlides(gallery).findIndex((slide) => slide.classList.contains('is-active'));

    const updateButtons = () => {
      const slides = getGallerySlides(gallery);
      const index = getActiveIndex();
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index < 0 || index >= slides.length - 1;
    };

    const goToIndex = (index) => {
      const slides = getGallerySlides(gallery);
      const target = slides[index];
      if (!target || typeof gallery.setActiveMedia !== 'function') return;
      gallery.setActiveMedia(target.dataset.mediaId);
      window.setTimeout(updateButtons, 0);
    };

    prevBtn.addEventListener('click', () => {
      const index = getActiveIndex();
      if (index > 0) goToIndex(index - 1);
    });

    nextBtn.addEventListener('click', () => {
      const index = getActiveIndex();
      if (index >= 0 && index < getGallerySlides(gallery).length - 1) goToIndex(index + 1);
    });

    getGallerySlides(gallery).forEach((slide) => {
      const observer = new MutationObserver(updateButtons);
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    gallery.querySelector('.hindle-v2-product-gallery__viewer')?.addEventListener('slideChanged', updateButtons);
    updateButtons();
  }

  function bindGallery(gallery) {
    if (gallery.dataset.hindleV2GalleryBound === 'true') return;
    gallery.dataset.hindleV2GalleryBound = 'true';

    const thumbsEl = gallery.querySelector('[id^="GalleryThumbnails"]');
    const thumbSwiper = initThumbSwiper(gallery);
    if (thumbsEl && !thumbSwiper && typeof Swiper === 'undefined') {
      window.setTimeout(() => initThumbSwiper(gallery), 50);
    }

    bindGalleryNav(gallery);

    if (gallery.dataset.imageZoom !== 'hover' || gallery.closest('quick-add-modal')) return;

    gallery.querySelectorAll('.hindle-v2-product-gallery__frame--image').forEach(bindFrame);

    gallery.querySelectorAll('.product__media-item').forEach((slide) => {
      const observer = new MutationObserver(() => {
        if (!slide.classList.contains('is-active')) {
          resetFrame(slide.querySelector('.hindle-v2-product-gallery__frame--image'));
        }
      });
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    const viewerList = gallery.querySelector('.hindle-v2-product-gallery__media-list');
    if (viewerList) {
      viewerList.scrollLeft = 0;
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.hindle-v2-product-gallery').forEach(bindGallery);
  }

  function boot() {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  window.initHindleV2ProductGallery = init;
})();
